export const getCurrentTime = () => {
  const hours =
    new Date().getHours() <= 9
      ? `0${new Date().getHours()}`
      : new Date().getHours();
  const minutes =
    new Date().getMinutes() <= 9
      ? `0${new Date().getMinutes()}`
      : new Date().getMinutes();
  return `${hours}:${minutes}`;
};
export const getCurrentDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return mm + "/" + dd + "/" + yyyy;
};

export function subtractYearsAndGetFormattedDate(date, yearsToSubtract) {
  const adjustedDate = new Date(date);
  adjustedDate.setFullYear(date.getFullYear() - yearsToSubtract);

  const formattedDate = adjustedDate.toISOString().split("T")[0];
  return formattedDate;
}

export const getFormattedDate = (datetime) => {
  if (!datetime) return "NA";
  const date = new Date(datetime);
  const newDate = date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return newDate;
};

export const getRegularDate = (datetime) => {
  if (!datetime) return "";

  const date = new Date(datetime);

  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const citationDate = (datetime) => {
  if (!datetime) return "";

  const date = new Date(datetime);

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};
